export function isRenderablePhoto(value: unknown): value is string {
  if (typeof value !== "string") return false;
  const v = value.trim();
  if (!v) return false;
  if (v.startsWith("http://") || v.startsWith("https://") || v.startsWith("data:") || v.startsWith("blob:") || v.startsWith("/")) return true;
  return /\.(png|jpe?g|webp|gif|bmp|svg)$/i.test(v);
}

export function collectJobPhotoUrls(job: { photos?: string[] }, issues: { photo: string }[]): string[] {
  const merged = [
    ...(Array.isArray(job.photos) ? job.photos : []),
    ...issues.map((i) => i.photo),
  ].filter(isRenderablePhoto);

  const seen = new Set<string>();
  return merged.filter((url) => {
    if (seen.has(url)) return false;
    seen.add(url);
    return true;
  });
}
